import React, { useRef, useEffect } from 'react';
import { useHistory } from 'react-router-dom'
import SideNav, { NavItem, NavIcon, NavText } from '@trendmicro/react-sidenav';
import '@trendmicro/react-sidenav/dist/react-sidenav.css';
import { AiFillCloseCircle, AiOutlineUser, AiFillSetting, AiOutlineSearch, AiOutlineLogin, AiOutlineUserAdd } from 'react-icons/ai';
import { FaBluetooth } from 'react-icons/fa';
import Logo from '../../../assets/img/ares-logo.png'
import NoAvatar from '../../../assets/img/no-avatar.png'
import { remove } from './../../../utils/Storage'
import './SideBar.css'
import { Col, Row } from 'react-bootstrap';
import { MdDirectionsCar, MdSearch, MdSystemUpdate, MdTimelapse, MdStore, MdPerson } from 'react-icons/md';
import { AiOutlineFilePdf } from 'react-icons/ai'
import { useAuth } from '../../../providers/auth';
import config from '../../../config';

function SideBar(props) {
  const appVersion = config.getAppVersion();
  const env = config.getEnv();
  const history = useHistory();
  const { user } = useAuth();

  const wrapperRef = useRef(null);

  useEffect(() => {
    fixFields();
  }, [])

  function logout(e) {
    e.preventDefault();
    remove('token')
    remove('user')
  }

  function fixFields() {
    let email = user.email.length
    let enterprise = user.enterprise != null ? user.enterprise?.name?.length : 0
    if (email > 30) {
      user.email = user.email.substring(0, 30) + "..."
    }

    if (enterprise > 20) {
      user.enterprise.name = user.enterprise.name.substring(0, 20) + "..."
    }
  }

  return (
    <div ref={wrapperRef}>
      <SideNav
        className="AresSideBar"
        onSelect={(selected) => {
          history.push('/' + selected);
        }}
        expanded={true}
        onToggle={{}}
      >
        <div className="logo-area">
          <img src={Logo} alt="Ares Logo" className="logo" />
          {user &&
            <div>
              <Row>
                <Col className="profile">
                  <div className="profile">
                    <span className="profile-name">{user.name}</span>
                    <span className="profile-desc"><b>USUÁRIO: </b>{user.username}</span>
                    <span className="profile-desc"><b>E-MAIL: </b>{user.email}</span>
                    <span className="profile-last-desc"><b>ORGANIZAÇÃO: </b>{user.enterprise.name}</span>
                  </div>
                </Col>
              </Row>
            </div>
          }
        </div>
        {/* Minha conta */}
        {user ?
          <SideNav.Nav >
            <NavItem eventKey="profile">
              <NavIcon>
                <AiOutlineUser size='1.5em' />
              </NavIcon>
              <NavText>
                Perfil
              </NavText>
            </NavItem>

            <NavItem eventKey="my-devices">
              <NavIcon>
                <FaBluetooth size='1.5em' />
              </NavIcon>
              <NavText>
                Meus Dispositivos
              </NavText>
            </NavItem>

            {user.profile._id != '6086f578b3f7ce0def82f243' && user.profile._id != '6089aebd882b6b8c415c4de5' ?
              <NavItem eventKey="client-devices">
                <NavIcon>
                  <MdTimelapse size='1.5em' />
                </NavIcon>
                <NavText style={{ marginLeft: '2rem' }}>
                  Dispositivos
                </NavText>
              </NavItem> : null}

            {user.profile._id == "6086f50d46258e47f28ec9d5" ?
              <NavItem eventKey="enterprises">
                <NavIcon>
                  <MdStore size='1.5em' />
                </NavIcon>
                <NavText style={{ marginLeft: '2rem' }}>
                  Empresas
                </NavText>
              </NavItem>
              : null
            }
            {
              env == 'homolog' || env == 'production' || env == 'local' ?
                <NavItem eventKey="directions">
                  <NavIcon>
                    <MdDirectionsCar size='1.5em' />
                  </NavIcon>
                  <NavText className="side-menu-dropdown">
                    Viagens
                  </NavText>
                </NavItem> : null
            }
            {
              env == 'homolog' || env == 'production' || env == 'local' ?
                <NavItem eventKey="localizator">
                  <NavIcon>
                    <MdSearch size='1.5em' />
                  </NavIcon>
                  <NavText style={{ marginLeft: '2rem' }}>
                    Rastrear viagem
                  </NavText>
                </NavItem> : null
            }
            {user.profile._id == "6086f50d46258e47f28ec9d5" || user.profile._id == '60846a923c0c98d2837f2e42' ?
              <NavItem eventKey="select-user">
                <NavIcon>
                  <MdPerson size='1.5em' />
                </NavIcon>
                <NavText style={{ marginLeft: '2rem' }}>
                  Usuários
                </NavText>
              </NavItem> :
              <></>
            }

            {user.profile._id == "6086f50d46258e47f28ec9d5" &&
              <NavItem eventKey="firmware">
                <NavIcon>
                  <MdSystemUpdate size='1.5em' />
                </NavIcon>
                <NavText>
                  Firmwares
                </NavText>
              </NavItem>
            }

            <NavItem eventKey="reports">
              <NavIcon>
                <AiOutlineFilePdf size='1.5em' />
              </NavIcon>
              <NavText>
                Relatórios
              </NavText>
            </NavItem>

            <NavItem eventKey="settings">
              <NavIcon>
                <AiFillSetting size='1.5em' />
              </NavIcon>
              <NavText>
                Configurações
              </NavText>
            </NavItem>
            <hr />
            <NavItem eventKey="login" onClick={e => { logout(e) }}>
              <NavIcon>
                <AiFillCloseCircle size='1.5em' />
              </NavIcon>
              <NavText>
                Sair
              </NavText>
            </NavItem>
          </SideNav.Nav>
          :
          <SideNav.Nav >
            <NavItem eventKey="register">
              <NavIcon>
                <AiOutlineUserAdd size='1.5em' />
              </NavIcon>
              <NavText>
                Cadastre-se
              </NavText>
            </NavItem>
            <NavItem eventKey="login">
              <NavIcon>
                <AiOutlineLogin size='1.5em' />
              </NavIcon>
              <NavText>
                Login
              </NavText>
            </NavItem>
            <NavItem eventKey="localizator">
              <NavIcon>
                <AiOutlineSearch size='1.5em' />
              </NavIcon>
              <NavText>
                Localizador
              </NavText>
            </NavItem>
            <hr />

            <NavItem eventKey="#">
              <NavIcon>
                <AiFillCloseCircle size='1.5em' />
              </NavIcon>
              <NavText>
                Sair
              </NavText>
            </NavItem>

          </SideNav.Nav>
        }
        <span className="app-version">ARES WEB - v.{appVersion}</span>
        {env == 'homolog' && <p style={{ color: 'white', fontSize: 12, float: 'right', marginRight: '5px' }}>Homologação</p>}
      </SideNav>

    </div>
  );
}

export default SideBar;
